export default "__VITE_ASSET__B5K12eor__"